import api from './client';

/** Public: list employees for kiosk (no auth required) */
export async function fetchAttendanceEmployees(params = {}) {
  const { data } = await api.get('/api/attendance/employees', { params });
  return data || [];
}

export async function identifyAttendanceEmployee(payload) {
  const { data } = await api.post('/api/attendance/identify', payload);
  return data;
}

export async function punchAttendance(payload) {
  const { data } = await api.post('/api/attendance/punch', payload);
  return data;
}

export async function fetchAttendanceHistory(token, params = {}) {
  const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  const { data } = await api.get('/api/attendance/history', {
    params,
    ...config
  });
  return data || [];
}

export async function fetchEmployeeSelfHistory(payload) {
  const { data } = await api.post('/api/attendance/self/history', payload);
  return data || { records: [] };
}

export async function changeEmployeeSelfPin(payload) {
  const { data } = await api.post('/api/attendance/self/change-pin', payload);
  return data;
}

/** Public: get last punch status for employee. */
export async function fetchLastPunch(employeeId, storeId) {
  const params = { employeeId };
  if (storeId) params.storeId = storeId;
  const { data } = await api.get('/api/attendance/last', { params });
  return data || { type: null };
}
